import keycloak, {
  getIdToken,
  getParsedIdToken,
  getParsedToken,
  getToken,
} from '../../framework/utils/KeycloakUtils';
// import { BuiltinRole } from '../constants';
import { UserInfo } from '../models/UserInfo';

// UserInfo
type KeycloakParsedTokenFieldToUse = {
  preferred_username: string;
  name: string;
  email: string;
  // Mapper
  outsourcer_code: string;
  tel: string;
  staff_id: string;
  name_k: string;
  occupation: string;
  role_id: number;
  family_name_k: string;
  given_name_k: string;
  facility_id: number; // Keycloakから渡されるfacility_pidは文字列である
  user_code: string;
  user_pid: number;
  role_type: number;
  personal_info_agreed: boolean;
  password_change_required: boolean;
};
let userInfo: UserInfo | undefined = undefined;
const getUserInfo = () => userInfo;
const setUserInfo = () => {
  const t = keycloak.tokenParsed as Keycloak.KeycloakTokenParsed &
    KeycloakParsedTokenFieldToUse;
  userInfo = {
    user_pid: t.user_pid,
    account: t.preferred_username || '',
    name: t.name || '',
    email: t.email || '',
    outsourcer_code: t.outsourcer_code || '',
    tel: t.tel || '',
    staffId: t.staff_id || '',
    name_k: t.name_k || '',
    occupation: t.occupation || '',
    role_id: [t.role_id],
    familyNameK: t.family_name_k || '',
    givenNameK: t.given_name_k || '',
    facility_id: t.facility_id,
    user_code: t.user_code || '',
    role_type: t.role_type,
    personal_info_agreed: t.personal_info_agreed || false,
    password_change_required: t.password_change_required || false,
    roleOptions: {
      isOutsourcer: t.role_type !== 0,
      isOutsourceMember: t.role_type === 2,
      isEnabledToLogin: t.role_type === 0 || t.role_type === 1,
    },
  };
  // debug
  // userInfo = {
  //   id: '5',
  //   account: 'GH0001',
  //   name: '法人　太郎',
  //   email: '',
  //   organizationCode: '02',
  //   tel: '',
  //   staffId: '',
  //   nameK: '',
  //   occupation: '',
  //   roleIds: ['5'],
  //   familyNameK: '',
  //   givenNameK: '',
  //   facilityPid: 1,
  //   userCode: 'GH0001',
  //   roleType: '1',
  //   personal_info_agree_required: false,
  //   password_change_required: false,
  // };

  return userInfo;
};
const overwriteUserInfo = (info: UserInfo | undefined) => {
  userInfo = info;
};

const clearUserInfo = () => {
  userInfo = undefined;
};

export const UserInfoAccessor = {
  getUserInfo,
  setUserInfo,
  clearUserInfo,
  getToken,
  getIdToken,
  getParsedToken,
  getParsedIdToken,
  overwriteUserInfo,
};
